export default __webpack_public_path__ + "static/interpolation-4a4cba7b26dc7ad1a19e69ec996bd07f.gif";